import api from './api.js';

class OrderPrintOptions {
    constructor(){
        this.url_orderPrintOptions = 'OrderPrintOptions'
    }
    all(){
      return api.get(`${this.url_orderPrintOptions}/`);
    }
}

export default new OrderPrintOptions;